import React from 'react'
import { useParams } from 'react-router-dom'

export default function StockEdit(props) {
    let {id} = useParams()
  return (
    <div>StockEdit : {id}</div>
  )
}
